module.exports = __webpack_public_path__ + "img/template1-fs8.1780a028.png";